import {
  SPONSOR_SOGANG,
  SPONSOR_STARTLINK,
  SPONSOR_MOBIS,
  SPONSOR_NAVERD2,
} from "./sponsor";

export const CWC_2022 = {
  nth: 1,
  year: 2022,
  dateStr: "2022년 5월 14일(토) 오후 2시 ~ 오후 5시",
  location: "서강대학교 리치과학관(R관) R912, R914호",
  links: {
    boj: "https://www.acmicpc.net/category/696",
  },
  awards: {
    round: {
      newbie: [
        {
          rank: 1,
          variant: "gold",
          solved: 8,
          name: "채성우",
          bojHandle: "lem0nad3",
        },
        {
          rank: 2,
          variant: "silver",
          solved: 7,
          name: "김도현",
          bojHandle: "jumping_fox",
        },
        {
          rank: 3,
          variant: "silver",
          solved: 6,
          name: "이준석",
          bojHandle: "junlee1216",
        },
        {
          rank: 4,
          variant: "bronze",
          solved: 6,
          name: "정회윤",
          bojHandle: "yunny_world",
        },
        {
          rank: 5,
          variant: "bronze",
          solved: 6,
          name: "박정빈",
          bojHandle: "jeongbin",
        },
        {
          rank: 6,
          variant: "bronze",
          solved: 5,
          name: "도정민",
          bojHandle: "blvdjm",
        },
      ],
      oldbie: [
        {
          rank: 1,
          variant: "gold",
          solved: 5,
          name: "조성훈",
          bojHandle: "shandy5833",
        },
        {
          rank: 2,
          variant: "silver",
          solved: 4,
          name: "강준성",
          bojHandle: "doongsae",
        },
        {
          rank: 3,
          variant: "silver",
          solved: 4,
          name: "노영현",
          bojHandle: "yhnoh8623",
        },
        {
          rank: 4,
          variant: "bronze",
          solved: 4,
          name: "성주희",
          bojHandle: "arkshart2",
        },
        {
          rank: 4,
          variant: "bronze",
          solved: 4,
          name: "류지성",
          bojHandle: "rwltjd",
        },
        {
          rank: 6,
          variant: "bronze",
          solved: 4,
          name: "김찬영",
          bojHandle: "bigwave100",
        },
      ],
    },
  },
  examiners: [
    {
      name: "박재형",
      bojHandle: "pjh6792",
      school: "라인플러스",
    },
    {
      name: "김동건",
      bojHandle: "dong_gas",
      school: "서강대학교",
    },
    {
      name: "한상필",
      bojHandle: "tkdvlf123",
      school: "그렙",
    },
    {
      name: "이재혁",
      bojHandle: "duram21",
      school: "서강대학교",
    },
    {
      name: "김정모",
      bojHandle: "meque98",
      school: "서강대학교",
    },
    {
      name: "이상원",
      bojHandle: "gumgood",
      school: "삼성전자",
    },
    {
      name: "손기령",
      bojHandle: "lickelon",
      school: "서강대학교",
    },
    {
      name: "박준서",
      bojHandle: "p_jun",
      school: "서강대학교",
    },
    {
      name: "강효규",
      bojHandle: "djs100201",
      school: "서강대학교",
    },
    {
      name: "김성현",
      bojHandle: "dart",
      school: "서강대학교",
    },
  ],
  checkers: [
    {
      name: "박신욱",
      bojHandle: "bnb2011",
      school: "DGIST",
    },
    {
      name: "서태수",
      bojHandle: "cheetose",
      school: "삼성전자",
    },
    {
      name: "최재민",
      bojHandle: "jh05013",
      school: "FuriosaAI",
    },
    {
      name: "박진한",
      bojHandle: "jinhan814",
      school: "고려대학교",
    },
    {
      name: "이국렬",
      bojHandle: "lky7674",
      school: "삼성전자",
    },
    {
      name: "김민상",
      bojHandle: "tony9402",
      school: "숭실대학교",
    },
    {
      name: "조원빈",
      bojHandle: "wbcho0504",
      school: "서강대학교",
    },
  ],
  sponsors: [SPONSOR_SOGANG, SPONSOR_STARTLINK, SPONSOR_MOBIS, SPONSOR_NAVERD2],
};
